/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 開栓作業時情報
 */
export interface Sgkb575aResTurnonWorkInfo {
    /**
     * 契約者情報変更有無フラグ：半角英数混在
     */
    ctrperinfoChangeyesnoFlg?: string;
    /**
     * 契約者情報変更有無フラグ名称：全角半角混在
     */
    ctrperinfoChangeyesnoFlgAname?: string;
    /**
     * 変更後　契約者お客さま漢字氏名：全角文字
     */
    afCtrperKnjnm?: string;
    /**
     * 変更後　契約者お客さまカナ氏名：全角カナ
     */
    afCtrperKananame?: string;
    /**
     * 変更後　契約者お客さま電話番号コード１：半角英数混在
     */
    afCtrperTeldivision1?: string;
    /**
     * 変更後　契約者お客さま電話番号コード１名称：全角半角混在
     */
    afCtrperTeldivision1Aname?: string;
    /**
     * 変更後　契約者お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    afCtrperTel1?: string;
    /**
     * 変更後　契約者お客さま電話番号コード２：半角英数混在
     */
    afCtrperTeldivision2?: string;
    /**
     * 変更後　契約者お客さま電話番号コード２名称：全角半角混在
     */
    afCtrperTeldivision2Aname?: string;
    /**
     * 変更後　契約者お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    afCtrperTel2?: string;
    /**
     * 変更後　契約者お客さま電話番号コード３：半角英数混在
     */
    afCtrperTeldivision3?: string;
    /**
     * 変更後　契約者お客さま電話番号コード３名称：全角半角混在
     */
    afCtrperTeldivision3Aname?: string;
    /**
     * 変更後　契約者お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    afCtrperTel3?: string;
    /**
     * 変更後　使用需要者区分：半角英数混在
     */
    afUsingjyuyoshaDiv?: string;
    /**
     * 変更後　使用需要者区分名称：全角半角混在
     */
    afUsingjyuyoshaDivAname?: string;
    /**
     * 変更後　使用者お客さま漢字氏名：全角文字
     */
    afUsrvstKnjnm?: string;
    /**
     * 変更後　使用者お客さまカナ氏名：全角カナ
     */
    afUsrvstKananame?: string;
    /**
     * 変更後　使用者お客さま電話番号コード１：半角英数混在
     */
    afUsrvstTeldivision1?: string;
    /**
     * 変更後　使用者お客さま電話番号コード１名称：全角半角混在
     */
    afUsrvstTeldivision1Aname?: string;
    /**
     * 変更後　使用者お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    afUsrvstTel1?: string;
    /**
     * 変更後　使用者お客さま電話番号コード２：半角英数混在
     */
    afUsrvstTeldivision2?: string;
    /**
     * 変更後　使用者お客さま電話番号コード２名称：全角半角混在
     */
    afUsrvstTeldivision2Aname?: string;
    /**
     * 変更後　使用者お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    afUsrvstTel2?: string;
    /**
     * 変更後　使用者お客さま電話番号コード３：半角英数混在
     */
    afUsrvstTeldivision3?: string;
    /**
     * 変更後　使用者お客さま電話番号コード３名称：全角半角混在
     */
    afUsrvstTeldivision3Aname?: string;
    /**
     * 変更後　使用者お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    afUsrvstTel3?: string;
}
